export default __webpack_public_path__ + "ff24cbce8f0f50235c993553c675d40e.png";